export const USER_TOKEN = "token";
export const IS_KEEP_ME_LOGGED_IN = "isKeepMeLoggedIn";
export const USER_ROLE = "userRole";
export const PAGINATION_LIMIT = 10;
export const roles = {
  is_service_provider: "is_service_provider",
  is_staff: "is_staff",
};
export const USER_WEBSITE_DOMAIN = "https://smshome.ae";
export const SECOND_LEVEL_CATEGORY_DETAILS_PAGE_KEYWORD = "category";
export const BOOKING_PAGE_KEYWORD = "book";
export const THIRD_LEVEL_CATEGORY_DETAILS_PAGE_KEYWORD = "package";
export const FOURTH_LEVEL_CATEGORY_DETAILS_PAGE_KEYWORD = "product";

export const initialTableData = {
  next: null,
  previous: null,
  count: 0,
  results: [],
};

export const SERVICE_FIELD_TYPE = {
  INTEGER: "IntegerField",
  TEXT: "TextField",
  CHARACTER: "CharField",
  BOOLEAN: "BooleanField",
  OPTIONS: "OptionField",
  DROPDOWN: "DropDownField",
  PRICE_COMBINATION: "PriceCombinationField",
  SECTION: "SectionField",
};

export const BANNER_DROPDOWN = [
  {
    display: "None",
    key: "none",
  },
  {
    display: "Service",
    key: "service",
  },
  {
    display: "Url",
    key: "url",
  },
];

export const SERVICE_FIELD_TYPE_OPTIONS = [
  {
    display: "Integer (Plus Minus button)",
    key: SERVICE_FIELD_TYPE.INTEGER,
  },
  {
    display: "Text Field (Description box)",
    key: SERVICE_FIELD_TYPE.TEXT,
  },
  {
    display: "Char Field (Single line text box)",
    key: SERVICE_FIELD_TYPE.CHARACTER,
  },
  {
    display: "Boolean Field (On Off switch)",
    key: SERVICE_FIELD_TYPE.BOOLEAN,
  },
  {
    display: "Option Field (Options without price calculations)",
    key: SERVICE_FIELD_TYPE.OPTIONS,
  },
  {
    display: "Price Combination Field (Options with price calculations)",
    key: SERVICE_FIELD_TYPE.PRICE_COMBINATION,
  },
  {
    display: "Drop Down Field (Dropdown)",
    key: SERVICE_FIELD_TYPE.DROPDOWN,
  },
  {
    display: "Section Filed (Separator)",
    key: SERVICE_FIELD_TYPE.SECTION,
  },
];

export const SESSIONS_TYPE = {
  AFTERNOON: "afternoon",
  MORNING: "morning",
  EVENING: "evening",
};

export const SESSIONS_TYPE_OPTIONS = [
  {
    display: "Morning",
    key: SESSIONS_TYPE.MORNING,
  },
  {
    display: "Afternoon",
    key: SESSIONS_TYPE.AFTERNOON,
  },
  {
    display: "Evening",
    key: SESSIONS_TYPE.EVENING,
  },
];

export const SERVICE_SESSION_DURATION_OPTIONS = [
  {
    display: "1 Hour",
    key: 60,
  },
  {
    display: "2 Hours",
    key: 120,
  },
  {
    display: "4 Hours",
    key: 240,
  },
];

export const SERVICE_SESSION_BOOKED_BEFORE_OPTIONS = [
  {
    display: "30 Mins",
    key: 30,
  },
  {
    display: "1 Hour",
    key: 60,
  },
  {
    display: "2 Hours",
    key: 120,
  },
  {
    display: "6 Hours",
    key: 360,
  },
  {
    display: "12 Hours",
    key: 720,
  },
  {
    display: "24 Hours",
    key: 1440,
  },
  {
    display: "48 Hours",
    key: 2880,
  },
];

export const PAGINATION_INITIAL_LIST_RES = {
  count: null,
  next: null,
  previous: null,
  results: [],
};

//SERVICE CONSTANTS
export const SERVICE_STATUS = {
  CREATED: "created",
  PAID: "paid",
  ACCEPTED: "accepted",
  IN_TRANSIT: "in_transit",
  AT_DESTINATION: "at_destination",
  COMPLETED_BY_PROVIDER: "completed_by_provider",
  COMPLETED: "completed",
  CANCELED: "cancelled",
  CANCELED_DUE_PAYMENT: "cancelled_due_Payment",
  CANCELED_BY_SUPPLIER: "cancelled_by_supplier",
  CANCELED_BY_CLIENT: "cancelled_by_client",
  IN_PROGRESS: "in_progress",
};

//SERVICE CONSTANTS
// export const SERVICE_STATUS_TYPES = [
//   { key: "created", display: "Created" },
//   { key: "paid", display: "Paid" },
//   { key: "accepted", display: "Accepted" },
//   { key: "in_transit", display: "In Transit" },
//   { key: "at_destination", display: "At Destination" },
//   { key: "completed_by_provider", display: "Completed By Provider" },
//   { key: "completed", display: "Completed" },
//   { key: "canceled", display: "Canceled" },
//   { key: "canceled_due_Payment", display: "Canceled Due Payment" },
//   { key: "canceled_by_supplier", display: "Canceled By Supplier" },
//   { key: "canceled_by_client", display: "Canceled By Client" },
// ];

export const WITHDRAWAL_TYPES = [
  { key: "&is_approved=false", display: "Pending" },
  { key: "", display: "All" },
];

export const CHART = [
  { key: "this_month", display: "This Month" },
  { key: "last_month", display: "Last Month" },
  { key: "this_year", display: "This Year" },
  { key: "last_year", display: "Last Year" },
  { key: "life_time", display: "Life Time" },
];
export const SUPPLIER_TYPES = [
  { key: "&is_approved=true", display: "Approved" },
  { key: "&is_approved=false", display: "Pending" },
];

export const USER_ACTIVE_DELETED = [
  { key: "&is_deleted=false", display: "Active" },
  { key: "&is_deleted=true", display: "Deleted" },
];

export const AREAS_SERVED = [
  { key: "&is_deleted=true", display: "Colombo" },
  { key: "&is_deleted=true", display: "Mount Lavinia" },
  { key: "&is_deleted=true", display: "Maharagama" },
  { key: "&is_deleted=true", display: "Matara" },
  { key: "&is_deleted=true", display: "Galle" },
  { key: "&is_deleted=true", display: "Panadura" },
];

export const RESPONSE_CODE = [
  { key: "", display: "All" },
  { key: "&response_status_code=200", display: "200" },
  { key: "&response_status_code=201", display: "201" },
  { key: "&response_status_code=202", display: "202" },
  { key: "&response_status_code=204", display: "204" },
  { key: "&response_status_code=301", display: "301" },
  { key: "&response_status_code=302", display: "302" },
  { key: "&response_status_code=303", display: "303" },
  { key: "&response_status_code=304", display: "304" },
  { key: "&response_status_code=307", display: "307" },
  { key: "&response_status_code=400", display: "400" },
  { key: "&response_status_code=401", display: "401" },
  { key: "&response_status_code=403", display: "403" },
  { key: "&response_status_code=404", display: "404" },
  { key: "&response_status_code=405", display: "405" },
  { key: "&response_status_code=406", display: "406" },
  { key: "&response_status_code=412", display: "412" },
  { key: "&response_status_code=415", display: "415" },
  { key: "&response_status_code=500", display: "500" },
  { key: "&response_status_code=501", display: "501" },
  { key: "&response_status_code=502", display: "502" },
];

export const REQUEST_METHOD = [
  { key: "", display: "All" },
  { key: "&request_method=GET", display: "GET" },
  { key: "&request_method=POST", display: "POST" },
  { key: "&request_method=PATCH", display: "PATCH" },
  { key: "&request_method=DELETE", display: "DELETE" },
  { key: "&request_method=HEAD", display: "HEAD" },
];

export const GOOGLE_MAP_BASE_URL = "https://maps.googleapis.com/maps/api/";

export const MAP_ADDRES_FROM_LATLONG =
  GOOGLE_MAP_BASE_URL + "geocode/json?latlng=";

export const MAP_ADDRESS_FROM_TEXT =
  GOOGLE_MAP_BASE_URL + "place/textsearch/json?query=";

export const SERVICE_STATUS_VALUE = {
  CREATED: "created",
  ACCEPTED: "accepted",
  IN_TRANSIT: "in_transit",
  AT_DESTINATION: "at_destination",
  IN_PROGRESS: "in_progress",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
  CANCELLED_DUE_PAYMENT: "cancelled_due_payment",
  CANCELLED_BY_SUPPLIER: "cancelled_by_supplier",
  CANCELLED_BY_CLIENT: "cancelled_by_client",
};

export const SERVICE_STATUS_TYPES = [
  { key: SERVICE_STATUS_VALUE.CREATED, display: "Created" },
  { key: SERVICE_STATUS_VALUE.ACCEPTED, display: "Accepted" },
  { key: SERVICE_STATUS_VALUE.IN_TRANSIT, display: "In Transit" },
  { key: SERVICE_STATUS_VALUE.AT_DESTINATION, display: "At Destination" },
  { key: SERVICE_STATUS_VALUE.IN_PROGRESS, display: "In Progress" },
  { key: SERVICE_STATUS_VALUE.COMPLETED, display: "Completed" },
  { key: SERVICE_STATUS_VALUE.CANCELLED, display: "Cancelled" },
  {
    key: SERVICE_STATUS_VALUE.CANCELLED_DUE_PAYMENT,
    display: "Cancelled Due Payment",
  },
  {
    key: SERVICE_STATUS_VALUE.CANCELLED_BY_SUPPLIER,
    display: "Cancelled By Supplier",
  },
  {
    key: SERVICE_STATUS_VALUE.CANCELLED_BY_CLIENT,
    display: "Cancelled By Client",
  },
];

export const BANNER_POSITION = [
  { key: "1", display: "1 (Main Banner)" },
  { key: "2", display: "2 (Promotional Banner)" },
];

export const BANNER_TITLE_POSITION = [
  { key: "2", display: "2 (Promotional Banner Title)" },
];


// all country codes
export const COUNTRY_CODES = [
  { key: "93", display: "+93 (Afghanistan)" },
  { key: "355", display: "+355 (Albania)" },
  { key: "213", display: "+213 (Algeria)" },
  { key: "1684", display: "+1684 (American Samoa)" },
  { key: "376", display: "+376 (Andorra)" },
  { key: "244", display: "+244 (Angola)" },
  { key: "1264", display: "+1264 (Anguilla)" },
  { key: "672", display: "+672 (Antarctica)" },
  { key: "1268", display: "+1268 (Antigua and Barbuda)" },
  { key: "54", display: "+54 (Argentina)" },
  { key: "374", display: "+374 (Armenia)" },
  { key: "297", display: "+297 (Aruba)" },
  { key: "61", display: "+61 (Australia)" },
  { key: "43", display: "+43 (Austria)" },
  { key: "994", display: "+994 (Azerbaijan)" },
  { key: "1242", display: "+1242 (Bahamas)" },
  { key: "973", display: "+973 (Bahrain)" },
  { key: "880", display: "+880 (Bangladesh)" },
  { key: "1246", display: "+1246 (Barbados)" },
  { key: "375", display: "+375 (Belarus)" },
  { key: "32", display: "+32 (Belgium)" },
  { key: "501", display: "+501 (Belize)" },
  { key: "229", display: "+229 (Benin)" },
  { key: "1441", display: "+1441 (Bermuda)" },
  { key: "975", display: "+975 (Bhutan)" },
  { key: "591", display: "+591 (Bolivia)" },
  { key: "387", display: "+387 (Bosnia and Herzegovina)" },
  { key: "267", display: "+267 (Botswana)" },
  { key: "55", display: "+55 (Brazil)" },
  { key: "246", display: "+246 (British Indian Ocean Territory)" },
  { key: "1284", display: "+1284 (British Virgin Islands)" },
  { key: "673", display: "+673 (Brunei)" },
  { key: "359", display: "+359 (Bulgaria)" },
  { key: "226", display: "+226 (Burkina Faso)" },
  { key: "257", display: "+257 (Burundi)" },
  { key: "855", display: "+855 (Cambodia)" },
  { key: "237", display: "+237 (Cameroon)" },
  { key: "1", display: "+1 (Canada)" },
  { key: "238", display: "+238 (Cape Verde)" },
  { key: "1345", display: "+1345 (Cayman Islands)" },
  { key: "236", display: "+236 (Central African Republic)" },
  { key: "235", display: "+235 (Chad)" },
  { key: "56", display: "+56 (Chile)" },
  { key: "86", display: "+86 (China)" },
  { key: "61", display: "+61 (Christmas Island)" },
  { key: "61", display: "+61 (Cocos (Keeling) Islands)" },
  { key: "57", display: "+57 (Colombia)" },
  { key: "269", display: "+269 (Comoros)" },
  { key: "242", display: "+242 (Congo - Brazzaville)" },
  { key: "243", display: "+243 (Congo - Kinshasa)" },
  { key: "682", display: "+682 (Cook Islands)" },
  { key: "506", display: "+506 (Costa Rica)" },
  { key: "385", display: "+385 (Croatia)" },
  { key: "53", display: "+53 (Cuba)" },
  { key: "599", display: "+599 (Curaçao)" },
  { key: "357", display: "+357 (Cyprus)" },
  { key: "420", display: "+420 (Czech Republic)" },
  { key: "225", display: "+225 (Côte d’Ivoire)" },
  { key: "45", display: "+45 (Denmark)" },
  { key: "253", display: "+253 (Djibouti)" },
  { key: "1767", display: "+1767 (Dominica)" },
  { key: "1809", display: "+1809 (Dominican Republic)" },
  { key: "593", display: "+593 (Ecuador)" },
  { key: "20", display: "+20 (Egypt)" },
  { key: "503", display: "+503 (El Salvador)" },
  { key: "240", display: "+240 (Equatorial Guinea)" },
  { key: "291", display: "+291 (Eritrea)" },
  { key: "372", display: "+372 (Estonia)" },
  { key: "251", display: "+251 (Ethiopia)" },
  { key: "500", display: "+500 (Falkland Islands)" },
  { key: "298", display: "+298 (Faroe Islands)" },
  { key: "679", display: "+679 (Fiji)" },
  { key: "358", display: "+358 (Finland)" },
  { key: "33", display: "+33 (France)" },
  { key: "594", display: "+594 (French Guiana)" },
  { key: "689", display: "+689 (French Polynesia)" },
  { key: "241", display: "+241 (Gabon)" },
  { key: "220", display: "+220 (Gambia)" },
  { key: "995", display: "+995 (Georgia)" },
  { key: "49", display: "+49 (Germany)" },
  { key: "233", display: "+233 (Ghana)" },
  { key: "350", display: "+350 (Gibraltar)" },
  { key: "30", display: "+30 (Greece)" },
  { key: "299", display: "+299 (Greenland)" },
  { key: "1473", display: "+1473 (Grenada)" },
  { key: "590", display: "+590 (Guadeloupe)" },
  { key: "1671", display: "+1671 (Guam)" },
  { key: "502", display: "+502 (Guatemala)" },
  { key: "44", display: "+44 (Guernsey)" },
  { key: "224", display: "+224 (Guinea)" },
  { key: "245", display: "+245 (Guinea-Bissau)" },
  { key: "592", display: "+592 (Guyana)" },
  { key: "509", display: "+509 (Haiti)" },
  { key: "504", display: "+504 (Honduras)" },
  { key: "852", display: "+852 (Hong Kong)" },
  { key: "36", display: "+36 (Hungary)" },
  { key: "354", display: "+354 (Iceland)" },
  { key: "91", display: "+91 (India)" },
  { key: "62", display: "+62 (Indonesia)" },
  { key: "98", display: "+98 (Iran)" },
  { key: "964", display: "+964 (Iraq)" },
  { key: "353", display: "+353 (Ireland)" },
  { key: "44", display: "+44 (Isle of Man)" },
  { key: "972", display: "+972 (Israel)" },
  { key: "39", display: "+39 (Italy)" },
  { key: "1876", display: "+1876 (Jamaica)" },
  { key: "81", display: "+81 (Japan)" },
  { key: "44", display: "+44 (Jersey)" },
  { key: "962", display: "+962 (Jordan)" },
  { key: "7", display: "+7 (Kazakhstan)" },
  { key: "254", display: "+254 (Kenya)" },
  { key: "686", display: "+686 (Kiribati)" },
  { key: "965", display: "+965 (Kuwait)" },
  { key: "996", display: "+996 (Kyrgyzstan)" },
  { key: "856", display: "+856 (Laos)" },
  { key: "371", display: "+371 (Latvia)" },
  { key: "961", display: "+961 (Lebanon)" },
  { key: "266", display: "+266 (Lesotho)" },
  { key: "231", display: "+231 (Liberia)" },
  { key: "218", display: "+218 (Libya)" },
  { key: "423", display: "+423 (Liechtenstein)" },
  { key: "370", display: "+370 (Lithuania)" },
  { key: "352", display: "+352 (Luxembourg)" },
  { key: "853", display: "+853 (Macau)" },
  { key: "389", display: "+389 (Macedonia)" },
  { key: "261", display: "+261 (Madagascar)" },
  { key: "265", display: "+265 (Malawi)" },
  { key: "60", display: "+60 (Malaysia)" },
  { key: "960", display: "+960 (Maldives)" },
  { key: "223", display: "+223 (Mali)" },
  { key: "356", display: "+356 (Malta)" },
  { key: "692", display: "+692 (Marshall Islands)" },
  { key: "596", display: "+596 (Martinique)" },
  { key: "222", display: "+222 (Mauritania)" },
  { key: "230", display: "+230 (Mauritius)" },
  { key: "262", display: "+262 (Mayotte)" },
  { key: "52", display: "+52 (Mexico)" },
  { key: "691", display: "+691 (Micronesia)" },
  { key: "373", display: "+373 (Moldova)" },
  { key: "377", display: "+377 (Monaco)" },
  { key: "976", display: "+976 (Mongolia)" },
  { key: "382", display: "+382 (Montenegro)" },
  { key: "1664", display: "+1664 (Montserrat)" },
  { key: "212", display: "+212 (Morocco)" },
  { key: "258", display: "+258 (Mozambique)" },
  { key: "95", display: "+95 (Myanmar)" },
  { key: "264", display: "+264 (Namibia)" },
  { key: "674", display: "+674 (Nauru)" },
  { key: "977", display: "+977 (Nepal)" },
  { key: "31", display: "+31 (Netherlands)" },
  { key: "599", display: "+599 (Netherlands Antilles)" },
  { key: "687", display: "+687 (New Caledonia)" },
  { key: "64", display: "+64 (New Zealand)" },
  { key: "505", display: "+505 (Nicaragua)" },
  { key: "227", display: "+227 (Niger)" },
  { key: "234", display: "+234 (Nigeria)" },
  { key: "683", display: "+683 (Niue)" },
  { key: "672", display: "+672 (Norfolk Island)" },
  { key: "850", display: "+850 (North Korea)" },
  { key: "1670", display: "+1670 (Northern Mariana Islands)" },
  { key: "47", display: "+47 (Norway)" },
  { key: "968", display: "+968 (Oman)" },
  { key: "92", display: "+92 (Pakistan)" },
  { key: "680", display: "+680 (Palau)" },
  { key: "970", display: "+970 (Palestine)" },
  { key: "507", display: "+507 (Panama)" },
  { key: "675", display: "+675 (Papua New Guinea)" },
  { key: "595", display: "+595 (Paraguay)" },
  { key: "51", display: "+51 (Peru)" },
  { key: "63", display: "+63 (Philippines)" },
  { key: "48", display: "+48 (Poland)" },
  { key: "351", display: "+351 (Portugal)" },
  { key: "1787", display: "+1787 (Puerto Rico)" },
  { key: "974", display: "+974 (Qatar)" },
  { key: "262", display: "+262 (Reunion)" },
  { key: "40", display: "+40 (Romania)" },
  { key: "7", display: "+7 (Russia)" },
  { key: "250", display: "+250 (Rwanda)" },
  { key: "590", display: "+590 (Saint Barthélemy)" },
  { key: "290", display: "+290 (Saint Helena)" },
  { key: "1869", display: "+1869 (Saint Kitts and Nevis)" },
  { key: "1758", display: "+1758 (Saint Lucia)" },
  { key: "590", display: "+590 (Saint Martin)" },
  { key: "508", display: "+508 (Saint Pierre and Miquelon)" },
  { key: "1784", display: "+1784 (Saint Vincent and the Grenadines)" },
  { key: "685", display: "+685 (Samoa)" },
  { key: "378", display: "+378 (San Marino)" },
  { key: "239", display: "+239 (Sao Tome and Principe)" },
  { key: "966", display: "+966 (Saudi Arabia)" },
  { key: "221", display: "+221 (Senegal)" },
  { key: "381", display: "+381 (Serbia)" },
  { key: "248", display: "+248 (Seychelles)" },
  { key: "232", display: "+232 (Sierra Leone)" },
  { key: "65", display: "+65 (Singapore)" },
  { key: "1721", display: "+1721 (Sint Maarten)" },
  { key: "421", display: "+421 (Slovakia)" },
  { key: "386", display: "+386 (Slovenia)" },
  { key: "677", display: "+677 (Solomon Islands)" },
  { key: "252", display: "+252 (Somalia)" },
  { key: "27", display: "+27 (South Africa)" },
  { key: "82", display: "+82 (South Korea)" },
  { key: "211", display: "+211 (South Sudan)" },
  { key: "34", display: "+34 (Spain)" },
  { key: "94", display: "+94 (Sri Lanka)" },
  { key: "249", display: "+249 (Sudan)" },
  { key: "597", display: "+597 (Suriname)" },
  { key: "47", display: "+47 (Svalbard and Jan Mayen)" },
  { key: "268", display: "+268 (Swaziland)" },
  { key: "46", display: "+46 (Sweden)" },
  { key: "41", display: "+41 (Switzerland)" },
  { key: "963", display: "+963 (Syria)" },
  { key: "886", display: "+886 (Taiwan)" },
  { key: "992", display: "+992 (Tajikistan)" },
  { key: "255", display: "+255 (Tanzania)" },
  { key: "66", display: "+66 (Thailand)" },
  { key: "670", display: "+670 (Timor-Leste)" },
  { key: "228", display: "+228 (Togo)" },
  { key: "690", display: "+690 (Tokelau)" },
  { key: "676", display: "+676 (Tonga)" },
  { key: "1868", display: "+1868 (Trinidad and Tobago)" },
  { key: "216", display: "+216 (Tunisia)" },
  { key: "90", display: "+90 (Turkey)" },
  { key: "993", display: "+993 (Turkmenistan)" },
  { key: "1649", display: "+1649 (Turks and Caicos Islands)" },
  { key: "688", display: "+688 (Tuvalu)" },
  { key: "1340", display: "+1340 (U.S. Virgin Islands)" },
  { key: "256", display: "+256 (Uganda)" },
  { key: "380", display: "+380 (Ukraine)" },
  { key: "971", display: "+971 (United Arab Emirates)" },
  { key: "44", display: "+44 (United Kingdom)" },
  { key: "1", display: "+1 (United States)" },
  { key: "598", display: "+598 (Uruguay)" },
  { key: "998", display: "+998 (Uzbekistan)" },
  { key: "678", display: "+678 (Vanuatu)" },
  { key: "39", display: "+39 (Vatican City)" },
  { key: "58", display: "+58 (Venezuela)" },
  { key: "84", display: "+84 (Vietnam)" },
  { key: "681", display: "+681 (Wallis and Futuna)" },
  { key: "212", display: "+212 (Western Sahara)" },
  { key: "967", display: "+967 (Yemen)" },
  { key: "260", display: "+260 (Zambia)" },
  { key: "263", display: "+263 (Zimbabwe)" },
  { key: "358", display: "+358 (Åland Islands)" }
];